import React from "react";
import Select from "react-select";
import { GenerateEWayBillPayloadType } from "../../../commonTypes/invoiceGenerationTypes";
import { CalenderIcon } from "../../Icon";
import { Label } from "reactstrap";
import DatePicker from "react-datepicker";
import moment from "moment";
import { EWayBillReviewDataType } from "../../../redux/invoiceGeneration/invoiceGenrationTypes";
export const TRANSACTION_TYPE = [
  { value: "Regular", label: "Regular" },
  { value: "Bill/Ship To", label: "Bill/Ship To" },
  { value: "Bill/Dispatch To", label: "Bill/Dispatch To" },
  {
    value: "Combination of Bill To and Bill From",
    label: "Combination of Bill To and Bill From",
  },
];
export const MODE = [
  { value: "Road", label: "Road" },
  { value: "Air", label: "Air" },
  { value: "Ship", label: "Ship" },
  { value: "Rail", label: "Rail" },
];

export const VEHICLE_TYPE = [
  { value: "Regular", label: "Regular" },
  { value: "Over Dimensional Cargo", label: "Over Dimensional Cargo" },
];
export const SUB_SUPPLY_TYPE = [
  { value: "Supply", label: "Supply" },
  { value: "Import", label: "Import" },
  { value: "Export", label: "Export" },
  { value: "Job Work", label: "Job Work" },
  { value: "For Own Use", label: "For Own Use" },
  { value: "Job work Returns", label: "Job work Returns" },
  { value: "Sales Return", label: "Sales Return" },
  { value: "Others", label: "Others" },
  { value: "SKD/CKD/Lots", label: "SKD/CKD/Lots" },
  { value: "Line Sales", label: "Line Sales" },
  { value: "Recipient Not Known", label: "Recipient Not Known" },
  { value: "Exhibition or Fairs", label: "Exhibition or Fairs" },
];

type AppProps = {
  generateEWayBill: GenerateEWayBillPayloadType;
  inputDetailsError: any;
  setInputDetailsError: React.Dispatch<React.SetStateAction<any>>;
  setGenerateEWayBill: React.Dispatch<
    React.SetStateAction<GenerateEWayBillPayloadType>
  >;
  submitEWayBillForm: () => void;
  data: EWayBillReviewDataType;
};
const EWayBillGenerate = ({
  generateEWayBill,
  inputDetailsError,
  setInputDetailsError,
  setGenerateEWayBill,
  submitEWayBillForm,
  data,
}: AppProps) => {
  return (
    <div className="e-way-action-box p-0" style={{ height: "666px" }}>
      <div className="sub-heading-e-invoice  ml-0 p-3">E-Way Bill Actions</div>
      <hr className="m-0"></hr>
      <div className="form-group mt-2 p-3">
        <h6>FILL TRANSPORTATION DEATILS</h6>
        <div className="row">
          <div className="col-md-6">
            <label>Transaction Type</label>
            <Select<any, false>
              inputProps={{ autoComplete: "nope" }}
              placeholder={"Select Type"}
              isDisabled
              options={[]}
              className={` ${
                inputDetailsError?.transactionType ? "error-border" : ""
              }`}
              value={{
                value: TRANSACTION_TYPE[0]?.value,
                label: TRANSACTION_TYPE[0]?.label,
              }}
              onChange={(e: any) => {
                setGenerateEWayBill((prv: GenerateEWayBillPayloadType) => {
                  return {
                    ...prv,
                    transaction_type: e?.value,
                  };
                });
                setInputDetailsError((prv: any) => {
                  return {
                    ...prv,
                    transactionType: "",
                  };
                });
              }}
              isSearchable={true}
            />
          </div>
          <div className="col-md-6">
            <label>Transporter Name</label>
            <div className="d-flex flex-row position-relative">
              <input
                type="text"
                className={`form-control ${
                  inputDetailsError?.transporterName ? "error-border" : ""
                }`}
                name="transporter_name"
                value={generateEWayBill?.transporter_name}
                onChange={(e: any) => {
                  setGenerateEWayBill((prv: GenerateEWayBillPayloadType) => {
                    return {
                      ...prv,
                      transporter_name: e?.target?.value,
                    };
                  });
                }}
              />
            </div>
          </div>
        </div>
        <div className="row mt-3">
          <div className="col-md-6">
            <label>Transporter ID(GSTIN)</label>
            <div className="d-flex flex-row position-relative">
              <input
                type="text"
                className={`form-control ${
                  inputDetailsError?.transporterId ? "error-border" : ""
                }`}
                name="transporter_id"
                onChange={(e: any) => {
                  setGenerateEWayBill((prv: GenerateEWayBillPayloadType) => {
                    return {
                      ...prv,
                      transporter_id: e?.target?.value,
                    };
                  });
                }}
              />
            </div>
          </div>
          <div className="col-md-6">
            <label>
              Transportation Mode <span className="color-red">*</span>
            </label>
            <Select<any, false>
              inputProps={{ autoComplete: "nope" }}
              placeholder={"Select Mode"}
              className={` ${
                inputDetailsError?.transportationMode
                  ? "error-border rounded"
                  : ""
              }`}
              options={MODE}
              value={{
                value: generateEWayBill?.transportation_mode
                  ? generateEWayBill?.transportation_mode
                  : null,
                label: generateEWayBill?.transportation_mode
                  ? generateEWayBill?.transportation_mode
                  : "Select...",
              }}
              onChange={(e: any) => {
                setGenerateEWayBill((prv: GenerateEWayBillPayloadType) => {
                  return {
                    ...prv,
                    vehicle_type: "",
                    vehicle_number: "",
                    transportation_mode: e?.value,
                  };
                });
                setInputDetailsError((prv: any) => {
                  return {
                    ...prv,
                    transportationMode: "",
                  };
                });
              }}
              isSearchable={true}
            />
          </div>
        </div>
        <div className="row mt-3">
          <div className="col-md-6">
            <label>
              Vehicle Type{" "}
              {generateEWayBill?.transportation_mode === "Road" ? (
                <span className="color-red">*</span>
              ) : (
                ""
              )}
            </label>
            <Select<any, false>
              inputProps={{ autoComplete: "nope" }}
              placeholder={"Select Type"}
              options={VEHICLE_TYPE}
              className={`${
                inputDetailsError?.vehicleType ? "error-border rounded" : ""
              }`}
              isDisabled={generateEWayBill?.transportation_mode !== "Road"}
              value={{
                value: generateEWayBill?.vehicle_type
                  ? generateEWayBill?.vehicle_type
                  : null,
                label: generateEWayBill?.vehicle_type
                  ? generateEWayBill?.vehicle_type
                  : "Select...",
              }}
              isSearchable={true}
              onChange={(e: any) => {
                setGenerateEWayBill((prv: GenerateEWayBillPayloadType) => {
                  return {
                    ...prv,
                    vehicle_type: e?.value,
                  };
                });
                setInputDetailsError((prv: any) => {
                  return {
                    ...prv,
                    vehicleType: "",
                  };
                });
              }}
            />
          </div>
          <div className="col-md-6">
            <label>
              Vehicle Number{" "}
              {generateEWayBill?.transportation_mode === "Road" ? (
                <span className="color-red">*</span>
              ) : (
                ""
              )}
            </label>
            <div className="d-flex flex-row position-relative">
              <input
                type="text"
                disabled={generateEWayBill?.transportation_mode !== "Road"}
                className={`form-control ${
                  inputDetailsError?.vehicleNumber ? "error-border" : ""
                }`}
                name="vehicle_number"
                value={generateEWayBill?.vehicle_number}
                onChange={(e: any) => {
                  setGenerateEWayBill((prv: GenerateEWayBillPayloadType) => {
                    return {
                      ...prv,
                      vehicle_number: e?.target?.value,
                    };
                  });
                  setInputDetailsError((prv: any) => {
                    return {
                      ...prv,
                      vehicleNumber: "",
                    };
                  });
                }}
              />
            </div>
          </div>
        </div>
        <div className="row mt-3">
          <div className="col-md-6">
            <label>
              Sub Supply <span className="color-red">*</span>
            </label>
            <Select<any, false>
              inputProps={{ autoComplete: "nope" }}
              placeholder={"Select Mode"}
              options={SUB_SUPPLY_TYPE}
              className={` ${
                inputDetailsError?.subSupply ? "error-border rounded" : ""
              }`}
              value={{
                value: generateEWayBill?.sub_supply_type
                  ? generateEWayBill?.sub_supply_type
                  : null,
                label: generateEWayBill?.sub_supply_type
                  ? generateEWayBill?.sub_supply_type
                  : "Select...",
              }}
              onChange={(e: any) => {
                setGenerateEWayBill((prv: GenerateEWayBillPayloadType) => {
                  return {
                    ...prv,
                    sub_supply_type: e?.value,
                  };
                });
                setInputDetailsError((prv: any) => {
                  return {
                    ...prv,
                    subSupply: "",
                  };
                });
              }}
              isSearchable={true}
            />
          </div>
          <div className="col-md-6">
            <label>
              Transporter Document No.
              {generateEWayBill?.transportation_mode &&
                generateEWayBill?.transportation_mode !== "Road" && (
                  <span className="color-red">*</span>
                )}
            </label>
            <div className="d-flex flex-row position-relative">
              <input
                type="text"
                className={`form-control ${
                  inputDetailsError?.transporterDocumentNumber
                    ? "error-border"
                    : ""
                }`}
                name="transporter_document_number"
                value={generateEWayBill?.transporter_document_number}
                onChange={(e: any) => {
                  setGenerateEWayBill((prv: GenerateEWayBillPayloadType) => {
                    return {
                      ...prv,
                      transporter_document_number: e?.target?.value,
                    };
                  });
                }}
              />
            </div>
          </div>
        </div>
        <div className="row mt-3">
          <div className="col-md-6">
            <label htmlFor="dateOfBirth">Transporter Document Date</label>
            <div className="d-flex flex-row position-relative">
              <div className="date-picker-wraper mr-0 w-100">
                <Label className="mr-0 w-100">
                  <DatePicker
                    dateFormat="dd-MM-yyyy"
                    className={`form-control ${
                      inputDetailsError?.transporterDocumentDate
                        ? "error-border rounded"
                        : ""
                    }`}
                    selected={
                      generateEWayBill?.transporter_document_date
                        ? new Date(
                            moment(
                              `${generateEWayBill?.transporter_document_date}T00:00:00`,
                              "YYYY-MM-DD"
                            ).format("YYYY-MM-DD[T]HH:mm:ss")
                          )
                        : null
                    }
                    onChange={(e: any) => {
                      setGenerateEWayBill(
                        (prv: GenerateEWayBillPayloadType) => {
                          return {
                            ...prv,
                            transporter_document_date: e
                              ? moment(e).format("YYYY-MM-DD")
                              : null,
                          };
                        }
                      );
                      setInputDetailsError((prv: any) => {
                        return {
                          ...prv,
                          transporterDocumentDate: "",
                        };
                      });
                    }}
                    fixedHeight
                    showMonthDropdown
                    showYearDropdown
                    placeholderText="Select"
                  />
                  <span
                    className="calender-icon"
                    style={{
                      right: "20px",
                      top: "10px",
                      cursor: "pointer",
                    }}
                  >
                    <CalenderIcon />
                  </span>
                </Label>
              </div>
            </div>
          </div>
          <div className="col-md-6">
            <label>
              Transportation Distance <span className="color-red">*</span>
            </label>
            <div className="d-flex flex-row position-relative">
              <input
                type="number"
                className={`form-control ${
                  inputDetailsError?.transportationDistance
                    ? "error-border"
                    : ""
                }`}
                onChange={(e: any) => {
                  setGenerateEWayBill((prv: GenerateEWayBillPayloadType) => {
                    return {
                      ...prv,
                      transportation_distance: +e?.target?.value,
                    };
                  });
                  setInputDetailsError((prv: any) => {
                    return {
                      ...prv,
                      transportationDistance: "",
                    };
                  });
                }}
                // disabled
                value={generateEWayBill?.transportation_distance}
                name="transportation_distance"
              />
            </div>
          </div>
        </div>
        <div className="row mt-4" style={{ marginBottom: "100px" }}>
          <div className="col-md-9">
            <button
              className="btn btn-primary mr-3"
              onClick={() => {
                submitEWayBillForm();
              }}
            >
              {data?.eway_bill_status === 2
                ? "Regenerate E-Way Bill"
                : "Generate E-Way Bill"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EWayBillGenerate;
